'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var index_esm = require('../../../node_modules/@date-io/moment/build/index.esm.js');
var React = require('react');
var useUtilsCfb96ac9 = require('../../../node_modules/@material-ui/pickers/esm/useUtils-cfb96ac9.js');
var TimePicker$1 = require('../../../node_modules/@material-ui/pickers/esm/TimePicker.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TimePicker = function TimePicker(props) {
  return React__default["default"].createElement(useUtilsCfb96ac9.M, {
    utils: index_esm
  }, React__default["default"].createElement(TimePicker$1.TimePicker, _objectSpread({}, props)));
};

module.exports = TimePicker;
